// Domestic/Global classification shared across order_recommendation and trade_suggestions.
// India ("IN") is Domestic; every other country code is Global. A null/unknown
// country_code is treated as Domestic so legacy Indian companies with an unset
// country don't disappear into Global.
export const INDIA_COUNTRY_CODE = "IN";

/**
 * True when a country code represents a Global (non-Indian) row. Null/undefined
 * codes are treated as Domestic and return false.
 */
export const isGlobalCountryCode = (
  countryCode: string | null | undefined,
): boolean => countryCode != null && countryCode !== INDIA_COUNTRY_CODE;
